module.exports = __webpack_public_path__ + "img/Brand.139ea1c3.svg";